import { Box, Container, Typography } from '@mui/material';
import { AppExpandableCell } from 'components/widgets/AppExpandableCell';
import { AppSearchInput } from 'components/widgets/AppSearchInput';
import React, { forwardRef, useState } from 'react';

const AppFaqView = forwardRef(({
    faqCategories,
    ...AppFaqViewProps
}, ref) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [expanded, setExpanded] = useState(false);

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value.toLowerCase());
    };

    const filterFAQs = (faqs) => {
        return faqs.filter(faq =>
            faq.question.toLowerCase().includes(searchQuery) ||
            faq.answer.toLowerCase().includes(searchQuery)
        );
    };


    return (
        <Container ref={ref} {...AppFaqViewProps}>
            <AppSearchInput
                placeholder="Search FAQs..."
                value={searchQuery}
                onChange={handleSearchChange}
                sx={{ mb: 4 }}
            />

            {/* FAQ Categories */}
            {Object.entries(faqCategories).map(([category, faqs]) => {
                const filteredFAQs = filterFAQs(faqs);
                if (searchQuery && filteredFAQs.length === 0) return null;

                return (
                    <Box key={category} sx={{ mb: 4 }}>
                        {(!searchQuery) && (
                            <Typography variant="h5" sx={{ textTransform: 'capitalize', mb: 2 }}>
                                {category} Questions
                            </Typography>
                        )}
                        {filteredFAQs.map((faq, index) => (

                            <AppExpandableCell
                                key={`${category}-${index}`}
                                expanded={expanded === `${category}-${index}`}
                                onChange={handleAccordionChange(`${category}-${index}`)}
                                summary={faq.question}
                                details={faq.answer}
                            />
                        ))}
                    </Box>
                );
            })}
        </Container>
    )
});

export { AppFaqView }